import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input number for product details form.
 */
export const InputProductNumber = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-number-error`,
  };

  const inputProps = {
    type: "text",
    id: `${product.sku}-input-product-number`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "DISPLAY NUMBER",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_NUMBER,
  };

  return <Input {...parentProps} />;
};
